import type { Promisable } from 'type-fest'
import type { AnyFn } from './type'

export type MaybeGetter<T> = T extends AnyFn ? () => T : (() => T) | T
export type MaybeAsyncGetter<T> = MaybeGetter<Promisable<T>>

export const resolveGetter = <T>(value: MaybeGetter<T>): T =>
  typeof value === 'function' ? value() : (value as T)
